export default __webpack_public_path__ + "img/bHoUHLqb.bb242e33.svg";